export class PlayerModel {
  name: "xxx"
  playerId: 'xxxxxx'
  userId: "xxxxxx"
  level: 0
  lastLoginRewardedAt: null
  credits: 550
  currentLevel: 0
}
